export function MinMaxInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  const { onBlur, ...inputProps } = props;

  return (
    <input
      type="number"
      onBlur={(e) => {
        enforceMinMax(e.currentTarget);
        onBlur?.(e);
      }}
      {...inputProps}
    />
  );
}

function enforceMinMax(target: HTMLInputElement) {
  if (target.value === "") {
    return;
  }

  const value = Number(target.value);
  if (!Number.isFinite(value)) {
    return;
  }

  let next = value;
  if (target.min !== "") {
    next = Math.max(next, Number(target.min));
  }
  if (target.max !== "") {
    next = Math.min(next, Number(target.max));
  }

  if (`${next}` !== target.value) {
    setInputValue(target, `${next}`);
    target.dispatchEvent(new Event("input", { bubbles: true }));
  }
}

function setInputValue(target: HTMLInputElement, value: string) {
  const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value")?.set;
  if (valueSetter) {
    valueSetter.call(target, value);
    return;
  }

  target.value = value;
}
